// this is an autogenerated file from App/Account/Content/Tasks/mutation-bulk-update-task-order.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Tasks($updates: [tasks_tasks_updates!]!) {
  update_tasks_tasks_many(updates: $updates) {
    affected_rows
    returning {
      id
      order
    }
  }
}

`